import config from 'config'
import lang from '@/lang'
import offerStates from '@/enums/offer/offer-state.enum'

const { OPEN, ACCEPTED, INVOICED, ORDER_CREATED, REJECTED } = offerStates

const urls = {
  single: 'offer',
  multiple: 'offers',
}

const resourceUrl = `${config.resourceHost}offer`

export default {
  resourceUrl,
  global: config,

  offerListSetting: `${config.resourceHost}setting/userlist/offer`,
  getNextOfferNumber: `${resourceUrl}/number`,
  getOfferFactorySetting: `${resourceUrl}/factorySetting`,
  getNewOffer: `${resourceUrl}/new`,
  preview: `${resourceUrl}/preview`,

  clientUrl: urls,

  routes: {
    details: `/${urls.single}/`,
    list: `${config.resourceHost}${urls.multiple}`,
  },

  filters: [
    {
      name: 'all',
      title: lang.label.allCapital,
      quickFilter: {
        state: {
          type: 'set',
          values: [],
        },
      },
    },
    {
      name: 'open',
      title: lang.open,
      quickFilter: {
        state: {
          type: 'set',
          values: [OPEN],
        },
      },
    },
    {
      name: 'accepted',
      title: lang.accepted,
      quickFilter: {
        state: {
          type: 'set',
          values: [ACCEPTED],
        },
      },
    },
    {
      name: 'invoiced',
      title: lang.invoiceCreated,
      quickFilter: {
        state: {
          type: 'set',
          values: [INVOICED],
        },
      },
    },
    {
      name: 'orderCreated',
      title: lang.orderCreated,
      quickFilter: {
        state: {
          type: 'set',
          values: [ORDER_CREATED],
        },
      },
    },
    {
      name: 'rejected',
      title: lang.rejected,
      quickFilter: {
        state: {
          type: 'set',
          values: [REJECTED],
        },
      },
    },
  ],
}
